import { render, staticRenderFns } from "./icon__envelope--20--tight.vue?vue&type=template&id=24df4568"
import script from "./icon__envelope--20--tight.vue?vue&type=script&lang=js"
export * from "./icon__envelope--20--tight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports